window.RecognitionAPI =  new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration.getBaseAPI("RecognitionServers"));

    self.getEmployeeTimeCardAttempts = function (brandId, userId, clockId) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/users/' + userId + '/clocks/' + clockId + '/attempts', 'GET')
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPunchPhotoReport = function (brandId, params) {

        var deferred = $q.defer();

        var payload = {
            start_date: moment(params.from_date).format('YYYY-MM-DD'),
            end_date: moment(params.to_date).format('YYYY-MM-DD')
        };

        _protected.request('brands/' + brandId + '/reports/users/clocks/attempts', 'GET', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getConfidenceTypeAttempts = function (brandId, date) {

        var deferred = $q.defer();

        var payload = {
            confidence: self.CONFIDENCE_TYPE.LOW,
            start_date: date.from_date.format('YYYY-MM-DD'),
            end_date: date.to_date.format('YYYY-MM-DD'),
        };

        _protected.request('brands/' + brandId + '/users/clocks/attempts', 'GET', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.RECOGNITION_ACTIONS = {
        SCHEDULED_CLOCK_IN: {
            code: "SCHEDULED_CLOCK_IN",
            text: $filter('translate')("Clock-in (Scheduled)")
        },
        EARLY_CLOCK_IN: {
            code: "EARLY_CLOCK_IN",
            text: $filter('translate')("Early Clock-in")
        },
        EARLY_CLOCK_OUT: {
            code: "EARLY_CLOCK_OUT",
            text: $filter('translate')("Early Clock-out")
        },
        UNSCHEDULED_CLOCK_IN: {
            code: "UNSCHEDULED_CLOCK_IN",
            text: $filter('translate')("Clock-in (Unscheduled)")
        },
        SCHEDULED_CLOCK_OUT: {
            code: "SCHEDULED_CLOCK_OUT",
            text: $filter('translate')("Clock-out (Scheduled)")
        },
        UNSCHEDULED_CLOCK_OUT: {
            code: "UNSCHEDULED_CLOCK_OUT",
            text: $filter('translate')("Clock-out (Unscheduled)")
        },
        BREAK_IN: {
            code: "BREAK_IN",
            text: $filter('translate')("Break-in")
        },
        BREAK_OUT: {
            code: "BREAK_OUT",
            text: $filter('translate')("Break-out")
        },
        LATE_CLOCK_IN: {
            code: "LATE_CLOCK_IN",
            text: $filter('translate')("Late Clock-in")
        },
        LATE_CLOCK_OUT: {
            code: "LATE_CLOCK_OUT",
            text: $filter('translate')("Late Clock-out")
        },
        LATE_BREAK_IN: {
            code: "LATE_BREAK_IN",
            text: $filter('translate')("Late Break-in")
        },
        EARLY_BREAK_IN :{
            code: "EARLY_BREAK_IN",
            text: $filter('translate')("Early Break-in")
        },
        EARLY_BREAK_OUT: {
            code: "EARLY_BREAK_OUT",
            text: $filter('translate')("Early Break-out")
        },
        LATE_BREAK_OUT: {
            code: "LATE_BREAK_OUT",
            text: $filter('translate')("Late Break-out")
        },
        EARLY_CLOCK_IN_ADMIN_APPROVAL: {
            code: "EARLY_CLOCK_IN_ADMIN_APPROVAL",
            text: $filter('translate')("Early Clock-in Manager Approval")
        },
        EARLY_CLOCK_OUT_ADMIN_APPROVAL: {
            code: "EARLY_CLOCK_OUT_ADMIN_APPROVAL",
            text: $filter('translate')("Early Clock-out Manager Approval")
        },
        LATE_CLOCK_IN_ADMIN_APPROVAL: {
            code: "LATE_CLOCK_IN_ADMIN_APPROVAL",
            text: $filter('translate')("Late Clock-in Manager Approval")
        },
        LATE_CLOCK_OUT_ADMIN_APPROVAL: {
            code: "LATE_CLOCK_OUT_ADMIN_APPROVAL",
            text: $filter('translate')("Late Clock-out Manager Approval")
        },
        UNSCHEDULED_CLOCK_IN_ADMIN_APPROVAL: {
            code: "UNSCHEDULED_CLOCK_IN_ADMIN_APPROVAL",
            text: $filter('translate')("Unscheduled Clock-in Manager Approval")
        },
        UNSCHEDULED_CLOCK_OUT_ADMIN_APPROVAL: {
            code: "UNSCHEDULED_CLOCK_OUT_ADMIN_APPROVAL",
            text: $filter('translate')("Unscheduled Clock-out Manager Approval")
        },
        SCHEDULED_CLOCK_IN_ADMIN_APPROVAL: {
            code: "SCHEDULED_CLOCK_IN_ADMIN_APPROVAL",
            text: $filter('translate')("Scheduled Clock-in Manager Approval")
        },
        SCHEDULED_CLOCK_OUT_ADMIN_APPROVAL: {
            code: "SCHEDULED_CLOCK_OUT_ADMIN_APPROVAL",
            text: $filter('translate')("Scheduled Clock-out Manager Approval")
        },
        EARLY_BREAK_IN_ADMIN_APPROVAL: {
            code: "EARLY_BREAK_IN_ADMIN_APPROVAL",
            text: $filter('translate')("Early Break-in Manager Approval")
        },
        LATE_BREAK_IN_ADMIN_APPROVAL: {
            code: "LATE_BREAK_IN_ADMIN_APPROVAL",
            text: $filter('translate')("Late Break-in Manager Approval")
        },
        EARLY_BREAK_OUT_ADMIN_APPROVAL: {
            code: "EARLY_BREAK_OUT_ADMIN_APPROVAL",
            text: $filter('translate')("Early Break-out Manager Approval")
        },
        LATE_BREAK_OUT_ADMIN_APPROVAL: {
            code: "LATE_BREAK_OUT_ADMIN_APPROVAL",
            text: $filter('translate')("Late Break-out Manager Approval")
        },
        BREAK_OUT_ADMIN_APPROVAL: {
            code: "BREAK_OUT_ADMIN_APPROVAL",
            text: $filter('translate')("Break-out Manager Approval")
        },
        BREAK_IN_ADMIN_APPROVAL: {
            code: "BREAK_IN_ADMIN_APPROVAL",
            text: $filter('translate')("Break-in Manager Approval")
        }
    };

    self.RECOGNITION_STATUS = {
        SUCCESS: {
            code: "SUCCESS",
            text: $filter('translate')("Success")
        },
        FAILURE: {
            code: "FAILURE",
            text: $filter('translate')("Failed")
        }
    };

    self.CONFIDENCE_TYPE = {
      LOW: 'LOW',
      HIGH: 'HIGH',
      NONE: 'NONE'
    }

    self.ATTEMPTS_BLOCKER_MODES = {
        BLOCKER: 'BLOCKER',
    }

    self.ATTEMPTS_TYPES = {
        FACIAL: 'FACIAL',
    }
};